import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVoterAuth } from '../contexts/VoterAuthContext';
import client from '../api/client';

export default function CastVote() {
  const { voter } = useVoterAuth();
  const navigate = useNavigate();
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [selectedCandidateName, setSelectedCandidateName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!voter) { navigate('/vote/login'); return; }
    client.get('/voter/me').then(res => {
      const constId = res.data.constituency_id;
      return client.get('/candidates/public?constituency_id=' + constId);
    }).then(res => {
      setCandidates(res.data);
    }).catch(() => {
      client.get('/candidates/public').then(res => setCandidates(res.data)).catch(() => {});
    });
  }, [voter, navigate]);

  const handleSelectCandidate = (candidate) => {
    if (!selectedCandidateName) {
      setSelectedCandidateName(candidate.name);
    }
    setSelectedCandidateId(candidate.id);
  };

  const handleVote = async () => {
    if (!selectedCandidateId) return;
    setLoading(true);
    setError('');
    try {
      const res = await client.post('/votes', { candidate_id: selectedCandidateId });
      localStorage.setItem('vote_receipt', JSON.stringify({
        receipt_code: res.data.receipt_code,
        candidate_name: selectedCandidateName,
        vote_id: res.data.vote_id
      }));
      navigate('/vote/confirmation');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to cast vote');
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <h1>Cast Your Vote</h1>
      <p>Select a candidate from your constituency and confirm your vote.</p>
      {error && <div className="error-msg">{error}</div>}
      <div className="candidates-list">
        {candidates.map(candidate => (
          <div
            key={candidate.id}
            className={`candidate-card ${selectedCandidateId === candidate.id ? 'selected' : ''}`}
            onClick={() => handleSelectCandidate(candidate)}
          >
            <h3>{candidate.name}</h3>
            <p>Party: {candidate.party_name}</p>
            <p>Constituency: {candidate.constituency_name}</p>
          </div>
        ))}
      </div>
      {selectedCandidateId && (
        <div className="vote-action">
          <p>Selected: {candidates.find(c => c.id === selectedCandidateId)?.name}</p>
          <button
            onClick={handleVote}
            disabled={loading}
            className="btn-primary"
          >
            {loading ? 'Submitting...' : 'Confirm Vote'}
          </button>
        </div>
      )}
    </div>
  );
}
